const initState = {
	projects: [
		{ id: '1', title: 'dhssalfbns', content: 'yo' },
		{ id: '2', title: '111111', content: 'yoyo' },
		{ id: '3', title: 'fdsgafddf', content: 'yoyoyo' },
	]
}

const projectReducer = (state = initState, action) => {
	switch (action.type) {
		case 'CREATE_PROJECT':
			// console.log('created project', action.project)
			return state;
		case 'CREATE_PROJECT_ERROR':
			// console.log('create project error', action.err)
			return state;
		case 'SIGN_PROJECT':
			// console.log('signed project', action.project)
			return state;
		case 'SIGN_PROJECT_ERROR':
			// console.log('signed project error', action.err)
			return state;
		case 'INCREMENT_COUNT':
			// console.log('signed project', action.project)
			return state;
		case 'INCREMENT_COUNT_ERROR':
			// console.log('signed project error', action.err)
			return state;

		case 'ADD_PAYMENT_METHOD':
			// console.log('signed project', action.project)
			return state;
		case 'ADD_PAYMENT_METHOD_ERROR':
			return state;

		case 'UNSUBSCRIBE_STRIPE':
			// console.log('signed project', action.project)
			return state;
		case 'UNSUBSCRIBE_STRIPE_ERROR':
			return state;

		case 'UPLOAD_AND_SIGN_PROJECT':
			// console.log('signed project', action.project)
			return state;
		case 'UPLOAD_AND_SIGN_PROJECT_ERROR':
			// console.log('signed project error', action.err)
			return state;
		case 'REGISTER_SIGN':
			// console.log("register sign", action)
			return state;
		case 'REGISTER_SIGN_ERROR':
			return state;
		case 'UPDATE_USER_PROFILE':
			return state;
		case 'UPDATE_USER_PROFILE_ERROR':
			return state;
		case 'DISCARD_PROJECT':
			return state;
		case 'DISCARD_PROJECT_ERROR':
			return state;
		default:
			return state;
	}
}

export default projectReducer;